// extracted by mini-css-extract-plugin
export default {"container":"WelcomeScreen_container__2+-4e","logoWrapper":"WelcomeScreen_logoWrapper__qJcsT","action":"WelcomeScreen_action__fSLa2"};